import React, { useState, Component } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { vehicles } from '../data/vehicles';
import { ChevronLeft, ChevronRight, MessageCircle, Phone, Calendar, Gauge, Fuel, Settings, Palette, Car, CheckCircle2, Share2, Heart } from 'lucide-react';
export function VehicleDetail() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const navigate = useNavigate();
  const vehicle = vehicles.find(v => v.id === Number(id));
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  if (!vehicle) {
    return <div className="min-h-[60vh] flex flex-col items-center justify-center" data-id="element-314">
        <h2 className="text-2xl font-bold text-[#1C1C1C] mb-4" data-id="element-315">
          Vehículo no encontrado
        </h2>
        <button onClick={() => navigate('/')} className="px-6 py-2 bg-[#4A90E2] text-white rounded-lg hover:bg-[#3A7BC8] transition-colors" data-id="element-316">
          Volver al catálogo
        </button>
      </div>;
  }
  const nextImage = () => {
    setCurrentImageIndex(prev => prev === vehicle.gallery.length - 1 ? 0 : prev + 1);
  };
  const prevImage = () => {
    setCurrentImageIndex(prev => prev === 0 ? vehicle.gallery.length - 1 : prev - 1);
  };
  const handleWhatsApp = () => {
    const message = `Hola Lusso Group, estoy interesado en el ${vehicle.year} ${vehicle.make} ${vehicle.model} ${vehicle.trim} publicado a ${vehicle.price}.`;
    window.open(`https://wa.me/5491100000000?text=${encodeURIComponent(message)}`, '_blank');
  };
  return <div className="max-w-[1200px] mx-auto px-4 py-8" data-id="element-317">
      {/* Breadcrumb & Actions */}
      <div className="flex items-center justify-between mb-6" data-id="element-318">
        <button onClick={() => navigate('/')} className="flex items-center text-gray-600 hover:text-[#4A90E2] transition-colors" data-id="element-319">
          <ChevronLeft className="w-5 h-5 mr-1" data-id="element-320" />
          Volver
        </button>
        <div className="flex items-center gap-3" data-id="element-321">
          <button className="p-2 rounded-full bg-white border border-[#D5D5D5] text-[#1C1C1C] hover:text-[#4A90E2] hover:border-[#4A90E2] transition-colors shadow-sm" data-id="element-322">
            <Share2 className="w-5 h-5" data-id="element-323" />
          </button>
          <button className="p-2 rounded-full bg-white border border-[#D5D5D5] text-[#1C1C1C] hover:text-[#D4A800] hover:border-[#D4A800] transition-colors shadow-sm" data-id="element-324">
            <Heart className="w-5 h-5" data-id="element-325" />
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-326">
        {/* Left Column: Gallery & Description */}
        <div className="lg:col-span-2 space-y-8" data-id="element-327">
          {/* Main Gallery */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-sm border border-[#D5D5D5]" data-id="element-328">
            <div className="relative aspect-[16/9] bg-[#E8E8E8] group" data-id="element-329">
              <img src={vehicle.gallery[currentImageIndex]} alt={`${vehicle.make} ${vehicle.model}`} className="w-full h-full object-cover" data-id="element-330" />

              {/* Gallery Controls */}
              <button onClick={prevImage} className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/80 backdrop-blur-sm flex items-center justify-center text-[#1C1C1C] hover:bg-white hover:text-[#4A90E2] transition-all opacity-0 group-hover:opacity-100 shadow-md" data-id="element-331">
                <ChevronLeft className="w-6 h-6" data-id="element-332" />
              </button>
              <button onClick={nextImage} className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/80 backdrop-blur-sm flex items-center justify-center text-[#1C1C1C] hover:bg-white hover:text-[#4A90E2] transition-all opacity-0 group-hover:opacity-100 shadow-md" data-id="element-333">
                <ChevronRight className="w-6 h-6" data-id="element-334" />
              </button>

              {/* Image Counter */}
              <div className="absolute bottom-4 right-4 px-3 py-1 rounded-full bg-black/50 backdrop-blur-sm text-white text-sm font-medium" data-id="element-335">
                {currentImageIndex + 1} / {vehicle.gallery.length}
              </div>
            </div>

            {/* Thumbnails */}
            <div className="flex gap-2 p-4 overflow-x-auto" data-id="element-336">
              {vehicle.gallery.map((img, idx) => <button key={idx} onClick={() => setCurrentImageIndex(idx)} className={`relative flex-shrink-0 w-24 aspect-[4/3] rounded-lg overflow-hidden border-2 transition-all ${currentImageIndex === idx ? 'border-[#4A90E2]' : 'border-transparent hover:border-[#D5D5D5]'}`} data-id="element-337">
                  <img src={img} alt={`Thumbnail ${idx + 1}`} className="w-full h-full object-cover" data-id="element-338" />
                </button>)}
            </div>
          </div>

          {/* Description */}
          <div className="bg-white rounded-2xl p-6 shadow-sm border border-[#D5D5D5]" data-id="element-339">
            <h3 className="text-xl font-bold text-[#1C1C1C] mb-4" data-id="element-340">
              Descripción del Vehículo
            </h3>
            <p className="text-gray-700 leading-relaxed whitespace-pre-line" data-id="element-341">
              {vehicle.description}
            </p>
          </div>

          {/* Equipment */}
          <div className="bg-white rounded-2xl p-6 shadow-sm border border-[#D5D5D5]" data-id="element-342">
            <h3 className="text-xl font-bold text-[#1C1C1C] mb-4" data-id="element-343">
              Equipamiento Destacado
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-344">
              {vehicle.equipment.map((item, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-345">
                  <CheckCircle2 className="w-5 h-5 text-[#4A90E2] flex-shrink-0 mt-0.5" data-id="element-346" />
                  <span className="text-gray-700" data-id="element-347">{item}</span>
                </div>)}
            </div>
          </div>
        </div>

        {/* Right Column: Info & CTAs */}
        <div className="space-y-6" data-id="element-348">
          {/* Price & Basic Info Card */}
          <div className="bg-white rounded-2xl p-6 shadow-sm border border-[#D5D5D5] sticky top-6" data-id="element-349">
            <div className="mb-6" data-id="element-350">
              <h1 className="text-3xl font-bold text-[#1C1C1C] mb-2 leading-tight" data-id="element-351">
                {vehicle.year} {vehicle.make} {vehicle.model}
              </h1>
              <p className="text-lg text-gray-500 mb-4" data-id="element-352">{vehicle.trim}</p>
              <div className="text-4xl font-bold text-[#4A90E2]" data-id="element-353">
                {vehicle.price}
              </div>
            </div>

            {/* Quick Specs Grid */}
            <div className="grid grid-cols-2 gap-4 mb-8" data-id="element-354">
              <div className="flex items-center gap-3 p-3 rounded-xl bg-[#E8E8E8]/50" data-id="element-355">
                <Calendar className="w-5 h-5 text-gray-500" data-id="element-356" />
                <div data-id="element-357">
                  <p className="text-xs text-gray-500" data-id="element-358">Año</p>
                  <p className="font-semibold text-[#1C1C1C]" data-id="element-359">{vehicle.year}</p>
                </div>
              </div>
              <div className="flex items-center gap-3 p-3 rounded-xl bg-[#E8E8E8]/50" data-id="element-360">
                <Gauge className="w-5 h-5 text-gray-500" data-id="element-361" />
                <div data-id="element-362">
                  <p className="text-xs text-gray-500" data-id="element-363">Kilometraje</p>
                  <p className="font-semibold text-[#1C1C1C]" data-id="element-364">
                    {vehicle.mileage}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-3 p-3 rounded-xl bg-[#E8E8E8]/50" data-id="element-365">
                <Settings className="w-5 h-5 text-gray-500" data-id="element-366" />
                <div data-id="element-367">
                  <p className="text-xs text-gray-500" data-id="element-368">Transmisión</p>
                  <p className="font-semibold text-[#1C1C1C] text-sm" data-id="element-369">
                    {vehicle.transmission}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-3 p-3 rounded-xl bg-[#E8E8E8]/50" data-id="element-370">
                <Fuel className="w-5 h-5 text-gray-500" data-id="element-371" />
                <div data-id="element-372">
                  <p className="text-xs text-gray-500" data-id="element-373">Combustible</p>
                  <p className="font-semibold text-[#1C1C1C]" data-id="element-374">{vehicle.fuel}</p>
                </div>
              </div>
            </div>

            {/* Detailed Specs List */}
            <div className="space-y-4 mb-8 border-t border-gray-100 pt-6" data-id="element-375">
              <div className="flex justify-between items-center" data-id="element-376">
                <span className="text-gray-500 flex items-center gap-2" data-id="element-377">
                  <Car className="w-4 h-4" data-id="element-378" /> Motor
                </span>
                <span className="font-medium text-[#1C1C1C] text-right" data-id="element-379">
                  {vehicle.engine}
                </span>
              </div>
              <div className="flex justify-between items-center" data-id="element-380">
                <span className="text-gray-500 flex items-center gap-2" data-id="element-381">
                  <Palette className="w-4 h-4" data-id="element-382" /> Color
                </span>
                <span className="font-medium text-[#1C1C1C]" data-id="element-383">
                  {vehicle.color}
                </span>
              </div>
            </div>

            {/* CTAs */}
            <div className="space-y-3" data-id="element-384">
              <button onClick={handleWhatsApp} className="w-full py-4 px-6 rounded-xl bg-[#25D366] hover:bg-[#128C7E] text-white font-bold text-lg flex items-center justify-center gap-2 transition-colors shadow-md" data-id="element-385">
                <MessageCircle className="w-6 h-6" data-id="element-386" />
                Consultar por WhatsApp
              </button>
              <button className="w-full py-4 px-6 rounded-xl bg-white border-2 border-[#1C1C1C] hover:bg-[#1C1C1C] hover:text-white text-[#1C1C1C] font-bold text-lg flex items-center justify-center gap-2 transition-colors" data-id="element-387">
                <Phone className="w-6 h-6" data-id="element-388" />
                Llamar al Concesionario
              </button>
            </div>

            {/* Trust Badges */}
            <div className="mt-6 p-4 rounded-xl bg-[#E8E8E8]/50 flex items-start gap-3" data-id="element-389">
              <CheckCircle2 className="w-6 h-6 text-[#4A90E2] flex-shrink-0" data-id="element-390" />
              <div data-id="element-391">
                <h4 className="font-semibold text-[#1C1C1C] text-sm" data-id="element-392">
                  Garantía Lusso Group
                </h4>
                <p className="text-xs text-gray-500 mt-1" data-id="element-393">
                  Vehículo inspeccionado en 150 puntos. Documentación al día,
                  listo para transferir.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}